import React from 'react'
import { Link } from 'react-router-dom'
import WatchlistOptionsMenu from './WatchlistOptionsMenu'
import { PageUrls } from './WatchListsRouter'
import styles from './watchlist-card.module.scss'
import WatchlistStats from './common/WatchlistStats'

interface Props {
  id: string
  name: string
  playerCount: number
  wtnSinglesAvg?: string
}

const WatchlistCard = ({ id, name, playerCount, wtnSinglesAvg }: Props) => (
  <article className={styles.container}>
    <header className={styles.header}>
      <Link to={`${PageUrls.DetailView}/${id}`} className={styles.name}>
        {name}
      </Link>
      <WatchlistOptionsMenu id={id} />
    </header>
    <WatchlistStats totalPlayers={playerCount} avgSinglesWtn={wtnSinglesAvg} />
  </article>
)

export default WatchlistCard
